<template>
  <div class="d-flex flex-column align-items-center w-100 w-xs-75 w-md-50 m-auto pt-5 pt-md-16">

    <img
      :src="require('@/assets/images/start.png')"
      alt=""
      style="width: 200px; height: 200px;"
      class="no-select">

    <h1 :class="headingStyle">Lets Begin Your Skin Analysis?</h1>

    <form
      @submit="saveCredentials($event)"
      novalidate="true"
      class="d-flex flex-column w-100">

      <div class="input w-100">
        <input
          id="firstName"
          v-model="userData.firstName"
          type="text"
          placeholder="First Name"
          class="input__field"
          :class="isInvalid('firstName') ? 'input__field--invalid' : null"
          autocomplete="off"
          @input="clearValidation('firstName')">
        <label
          for="firstName"
          v-for="(error, index) in validations.firstName"
          :key="`firstName-error-${index}`"
          v-show="!error.valid"
          class="input__error">
          <span>{{ error.message }}</span>
        </label>
      </div>

      <div class="input w-100">
        <input
          id="lastName"
          v-model="userData.lastName"
          type="text"
          placeholder="Last Name"
          class="input__field"
          :class="isInvalid('lastName') ? 'input__field--invalid' : null"
          autocomplete="off"
          @input="clearValidation('lastName')">
        <label
          for="lastName"
          v-for="(error, index) in validations.lastName"
          :key="`lastName-error-${index}`"
          v-show="!error.valid"
          class="input__error">
          <span>{{ error.message }}</span>
        </label>
      </div>

      <button
        type="submit"
        class="button button--main button--block mb-7"
        v-ripple>
        Start the Quiz
      </button>

    </form>

    <p class="small text-center">Exfoliate 1-2 times a week to keep your pores clear. Be consistent with your skincare routine, never skip out on SPF. Remember, too, that skin care products like serums and masks may contain </p>

  </div>
</template>

<script>
export default {
  name: 'Start',
  data() {
    return {
      userData: {
        firstName: '',
        lastName: '',
      },

      validations: {
        firstName: {
          required: {
            valid: true,
            message: 'Please enter your first name.',
          },
          minLength: {
            valid: true,
            message: 'First name must be longer than 3 letters.',
          }
        },
        lastName: {
          required: {
            valid: true,
            message: 'Please enter your last name.',
          },
          minLength: {
            valid: true,
            message: 'Last name must be longer than 3 letters.',
          }
        },
      },
    }
  },
  computed: {
    currentBreakpoint() {
      /// Returns current 'morphological' breakpoint value based on window width
      ///
      /// @example
      ///   'xs' | 'sm' | 'md' | 'lg' | 'xl'

      return this.$store.state.config.currentBreakpoint
    },

    isDesktop() {
      return this.currentBreakpoint == 'md' || this.currentBreakpoint == 'lg' || this.currentBreakpoint == 'xl'
    },

    isMobile() {
      return this.currentBreakpoint == 'xs' || this.currentBreakpoint == 'sm'
    },

    headingStyle() {
      if (this.isDesktop) return 'h1 mb-8'
      else return 'h4'
    },
  },
  methods: {
    validateForm(event) {
      event.preventDefault()

      const self = this
      let results = []

      return new Promise(resolve => {
        function testFirstname() {
          const firstName = self.userData.firstName
          const validations = self.validations.firstName

          // Required
          if (firstName && firstName.length > 0) {
            validations.required.valid = true
          } else {
            validations.required.valid = false
          }

          // Min Length
          if (firstName.length > 0 && firstName.length <= 3) {
            validations.minLength.valid = false
          } else {
            validations.minLength.valid = true
          }
        }

        function testLastname() {
          const lastName = self.userData.lastName
          const validations = self.validations.lastName

          // Required
          if (lastName && lastName.length > 0) {
            validations.required.valid = true
          } else {
            validations.required.valid = false
          }

          // Min Length
          if (lastName.length > 0 && lastName.length <= 3) {
            validations.minLength.valid = false
          } else {
            validations.minLength.valid = true
          }
        }

        function checkResults() {
          results = []

          Object.keys(self.validations).forEach(type => {
            const target = self.validations[ type ]

            Object.keys(target).forEach(param => {
              results.push(target[ param ].valid)
            })
          })
        }

        testFirstname()
        testLastname()
        checkResults()

        results.some(el => !el) ? resolve(false) : resolve(true)
      })
    },

    clearValidation(type) {
      const target = this.validations[ type ]

      Object.keys(target).forEach(key => {
        target[ key ].valid = true
      })
    },

    isInvalid(type) {
      const target = this.validations[ type ]
      const errors = []

      Object.keys(target).forEach(key => {
        errors.push(target[ key ].valid)
      })

      return errors.some(el => !el)
    },

    saveCredentials(event) {
      this.validateForm(event).then(result => {
        if (result) {

          this.$store.dispatch('user/sendUserCredentials', {
            firstName: this.userData.firstName,
            lastName: this.userData.lastName,
          })

          this.moveForward()
        }
      })
    },

    moveForward() {
      this.$store.commit('config/SET_CURRENT_TRANSITION', this.isDesktop ? 'fade-in-right' : 'overlay-down-full')
      setTimeout(() => {
        this.$router.push({ name: 'Scanner' })
      }, 100)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/@core/globals';
</style>
